import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer, Legend } from "recharts";

const AXES = [
  { key: "clarity", label: "Clarity" },
  { key: "usability", label: "Usability" },
  { key: "trust", label: "Trust" },
  { key: "value", label: "Value" },
  { key: "accessibility", label: "A11y" },
];

export function ObjectionRadar({ radar }) {
  if (!radar) return null;
  const data = AXES.map((a) => ({ axis: a.label, score: radar[a.key] ?? 0, target: 70 }));
  return (
    <div className="sim-card rounded-xl p-4" data-testid="sim-radar">
      <p className="sim-mono text-[11px] text-[#D4D4D8] uppercase tracking-wider mb-1">Objection Radar</p>
      <div className="h-[260px]">
        <ResponsiveContainer width="100%" height="100%">
          <RadarChart data={data} outerRadius="72%">
            <PolarGrid stroke="#27272A" />
            <PolarAngleAxis dataKey="axis" tick={{ fill: "#D4D4D8", fontSize: 11, fontFamily: "JetBrains Mono" }} />
            <PolarRadiusAxis domain={[0, 100]} tick={false} axisLine={false} />
            <Radar name="Industry Target" dataKey="target" stroke="#3f3f46" fill="#3f3f46" fillOpacity={0.12} strokeDasharray="4 4" />
            <Radar name="This Page" dataKey="score" stroke="#00F0FF" fill="#00F0FF" fillOpacity={0.3} isAnimationActive />
            <Legend wrapperStyle={{ fontSize: 10, fontFamily: "JetBrains Mono" }} />
          </RadarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
